<template>
  <div v-if="cropshow&&this.geoselect.length!=0">
    <!-- <VueDragResize :x="positionX" class="gis-info" :w="400" :h="infoheight" :snapToGrid="true" :gridY="220"> -->
    <!-- <div class="title">
            <b-row align-h="between">
                <b-col cols="10">
                    <h6 class="mb-0">農作物面積</h6>
                </b-col>
                <b-col cols="auto" class="pointer">
                  <b-button class="close-button" @click="closeWindow()" variant="outline-success">
                    <b-icon icon="x-circle" scale=".8" variant="white"></b-icon>
                  </b-button>
                </b-col>
            </b-row>
          </div> -->
    <!-- <b-collapse v-model="visible.chart1show" id="collapse-1" class="mt-2"> -->
    <div class="title">
      <b-row align-h="between">
          <b-col cols="10">
              <h6 class="mb-0">農作物面積</h6>
          </b-col>
      </b-row>
    </div>
    <apexchart
      width="350"
      height="220"
      ref="chartref"
      type="bar"
      :options="chartOptions"
      :series="series"
      @dataPointSelection="barSelectionEvent"
    ></apexchart>
    <!-- </b-collapse> -->
    <div class="title">
      <b-row align-h="between">
        <b-col md="auto">
          <h6 class="mb-0">農作物收獲量</h6>
        </b-col>
        <!-- <b-col v-if="visible.chart2show" md="auto">
                  <b-button @click="visible.chart2show = !visible.chart2show" variant="outline-success" size="sm">
                    <b-icon icon="arrows-angle-contract"></b-icon>
                  </b-button>
                </b-col>
                <b-col v-else md="auto">
                  <b-button @click="visible.chart2show= !visible.chart2show" variant="outline-success"  size="sm">
                    <b-icon icon="arrows-angle-expand"></b-icon>
                  </b-button>
                </b-col> -->
      </b-row>
    </div>
    <!-- <b-collapse v-model="visible.chart2show" id="collapse-2"> -->
    <apexchart
      width="350"
      height="220"
      ref="piechartref"
      type="pie"
      :options="pichart1.chartOptions"
      :series="pichart1.series"
      @dataPointSelection="pie1SelectionEvent"
    ></apexchart>
    <!-- </b-collapse> -->
    <div class="title">
      <b-row align-h="between">
        <b-col md="auto">
          <h6 class="mb-0">農作物每公頃收穫量</h6>
        </b-col>
        <!-- <b-col v-if="visible.chart3show" md="auto">
                  <b-button @click="visible.chart3show = !visible.chart3show" variant="outline-success" size="sm">
                    <b-icon icon="arrows-angle-contract"></b-icon>
                  </b-button>
                </b-col>
                <b-col v-else md="auto">
                  <b-button @click="visible.chart3show= !visible.chart3show" variant="outline-success"  size="sm">
                    <b-icon icon="arrows-angle-expand"></b-icon>
                  </b-button>
                </b-col> -->
      </b-row>
    </div>
    <!-- <b-collapse v-model="visible.chart3show" id="collapse-3"> -->
    <apexchart
      width="350"
      height="220"
      ref="piechartref2"
      type="pie"
      :options="pichart2.chartOptions"
      :series="pichart2.series"
      @dataPointSelection="pie2SelectionEvent"
    ></apexchart>
    <!-- </b-collapse> -->
    <!-- </VueDragResize> -->
  </div>
</template>

<script>
// import VueDragResize from 'vue-drag-resize';

export default {
  name: "DragCropInfoChart",
  data() {
    return {
      cropshow: false,
      series: [],
      positionX: 0,
      chartOptions: {
        chart: {
          type: "bar",
          height: 220,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: "面積",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " 公頃";
            },
          },
        },
      },
      dataseries: {
        AREA_P: {
          name: "種植面積",
          data: [],
        },
        AREA_H: {
          name: "收穫面積",
          data: [],
        },
      },
      tmp: null,
      pichart1: {
        series: [],
        chartOptions: {
          chart: {
            height: 220,
            type: "pie",
          },
          labels: [],
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 公斤";
              },
            },
          },
          colors: [
            "#F94144",
            "#277DA1",
            "#F3722C",
            "#577590",
            "#F8961E",
            "#4D908E",
            "#F9844A",
            "#43AA8B",
            "#F9C74F",
            "#90BE6D",
            "#E8D7CB",
            "#B8B8B8",
            "#AC9477",
            "#7A7A7A",
            "#583A0E",
            "#010C13",
            "#352B1C",
            "#250001",
            "#6F5C5D",
            "#3D0003",
            "#470063",
            "#EABFCB",
            "#FF0A5C",
            "#4f2935",
            "#C191A1",
            "#353229",
            "#9f0b36",
            "#fc05d7",
            "#d2a9f3",
            "#9b6a6c",
          ],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 350,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
        dataseries: {
          HARVEST: {
            data: [],
          },
        },
      },
      pichart2: {
        series: [],
        chartOptions: {
          chart: {
            height: 220,
            type: "pie",
          },
          labels: [],
          tooltip: {
            y: {
              formatter: function (val) {
                return " 每公頃收穫量: " + val;
              },
            },
          },
          colors: [
            "#F94144",
            "#277DA1",
            "#F3722C",
            "#577590",
            "#F8961E",
            "#4D908E",
            "#F9844A",
            "#43AA8B",
            "#F9C74F",
            "#90BE6D",
            "#E8D7CB",
            "#B8B8B8",
            "#AC9477",
            "#7A7A7A",
            "#583A0E",
            "#010C13",
            "#352B1C",
            "#250001",
            "#6F5C5D",
            "#3D0003",
            "#470063",
            "#EABFCB",
            "#FF0A5C",
            "#4f2935",
            "#C191A1",
            "#353229",
            "#9f0b36",
            "#fc05d7",
            "#d2a9f3",
            "#9b6a6c",
          ],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 350,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
        dataseries: {
          RATE_H: {
            data: [],
          },
        },
      },
      visible: {
        chart1show: false,
        chart2show: false,
        chart3show: false,
      },
    };
  },
  // components: {
  //     VueDragResize
  // },
  props: {
    infoheight: Number,
    cropArea: null,
    cropInfoShow: Boolean,
    gisobject: null,
    returnthis: Function,
    geoselect: Array,
    geotabs: Number
  },
  mounted() {
    this.returnthis(this);
    //this.init();
  },
  methods: {
    // init() {
    //   if (this.cropArea.length != 0) {
    //   }
    // },
    barSelectionEvent(event, chartContext, config) {
      let index = null;
      this.tmp = chartContext;
      var barallelements = document.getElementsByClassName(
        "apexcharts-bar-area"
      );
      var piecharts = document.getElementsByClassName("apexcharts-pie-area");
      for (let i = 0; i < barallelements.length; i++) {
        if (barallelements[i].id == event.target.id) {
          index = i;
          barallelements[i].style.opacity = "1";
        } else {
          barallelements[i].style.opacity = "0.3";
        }
        //barallelements[i].style.opacity=barallelements[i].id == event.path[0].id?"1":"0.3"
      }
      for (let y = 0; y < piecharts.length; y++) {
        let num1 = index % this.geoselect.length;
        let num2 = y % this.geoselect.length;
        piecharts[y].style.opacity = num1 == num2 ? "1" : "0.3";
      }
      let obj = {
        ANA_TOWN_ID : this.geoselect[config.dataPointIndex]
      }
      if(this.geotabs == 0) this.gisobject.changeStleByChart(obj)
      else if(this.geotabs == 1) this.gisobject.changeTaiwanStleByChart(obj)
    },
    pie1SelectionEvent(event, chartContext, config) {
      if (event != null && event != undefined) {
        let index = null;
        this.tmp = chartContext;
        var barallelements = document.getElementsByClassName(
          "apexcharts-bar-area"
        );
        var piecharts = document.getElementsByClassName("apexcharts-pie-area");
        for (let i = 0; i < piecharts.length; i++) {
          if (piecharts[i].id == event.target.id) {
            index = i;
          }
        }
        for (let y = 0; y < piecharts.length; y++) {
          let num = y % this.geoselect.length;
          piecharts[y].style.opacity = num == index ? "1" : "0.3";
        }
        for (let y = 0; y < barallelements.length; y++) {
          let num1 = index % this.geoselect.length;
          let num2 = y % this.geoselect.length;
          barallelements[y].style.opacity = num1 == num2 ? "1" : "0.3";
        }
        let obj = {
          ANA_TOWN_ID : this.geoselect[config.dataPointIndex]
        }
        if(this.geotabs == 0) this.gisobject.changeStleByChart(obj)
        else if(this.geotabs == 1) this.gisobject.changeTaiwanStleByChart(obj)
      }
    },
    pie2SelectionEvent(event, chartContext, config) {
      if (event != null && event != undefined) {
        console.log(event)
        let index = null;
        this.tmp = chartContext;
        var barallelements = document.getElementsByClassName(
          "apexcharts-bar-area"
        );
        var piecharts = document.getElementsByClassName("apexcharts-pie-area");
        console.log(piecharts)
        for (let i = 0; i < piecharts.length; i++) {
          if (piecharts[i].id == event.target.id) {
            let num = this.geoselect.length;
            index = i;
            piecharts[i].style.opacity = "1";
            let x = i - num;
            piecharts[x].style.opacity = "1";
          } else {
            piecharts[i].style.opacity = "0.3";
          }
        }
        for (let y = 0; y < barallelements.length; y++) {
          let num1 = index % this.geoselect.length;
          let num2 = y % this.geoselect.length;
          barallelements[y].style.opacity = num1 == num2 ? "1" : "0.3";
        }
        let obj = {
          ANA_TOWN_ID : this.geoselect[config.dataPointIndex]
        }
        if(this.geotabs == 0) this.gisobject.changeStleByChart(obj)
        else if(this.geotabs == 1) this.gisobject.changeTaiwanStleByChart(obj)
      }
    },
    changeBarSelection(index) {
      var barallelements = document.getElementsByClassName(
        "apexcharts-bar-area"
      );
      var piecharts = document.getElementsByClassName("apexcharts-pie-area");
      for (let i = 0; i < barallelements.length; i++) {
        let num = i % this.geoselect.length;
        barallelements[i].style.opacity = num == index ? "1" : "0.3";
      }
      for (let y = 0; y < piecharts.length; y++) {
        let num = y % this.geoselect.length;
        piecharts[y].style.opacity = num == index ? "1" : "0.3";
      }
    },
    chartRender(index) {
      this.chartInit();
      let survey = this.cropArea.BA_AGRI_SURVEY
        ? this.cropArea.BA_AGRI_SURVEY
        : this.cropArea.AGRI_SURVEY_TAIWAN;

      for (let i in survey) {
        let item = survey[i];
        // console.log([this.geoselect, item])
        if(!this.geoselect.includes(item.ANA_TOWN_ID)) {
          continue;
        }
        //建置Bar Chart
        this.dataseries.AREA_P.data.push(item.AREA_P);
        this.dataseries.AREA_H.data.push(item.AREA_H);
        this.chartOptions.xaxis.categories.push(item.TOWN);

        //建置Pie Chart
        this.pichart1.dataseries.HARVEST.data.push(item.HARVEST);
        this.pichart1.chartOptions.labels.push(item.TOWN);

        this.pichart2.dataseries.RATE_H.data.push(item.RATE_H);
        this.pichart2.chartOptions.labels.push(item.TOWN);
      }
      this.series.push(this.dataseries.AREA_P);
      this.series.push(this.dataseries.AREA_H);

      this.pichart1.series = this.pichart1.dataseries.HARVEST.data;
      this.pichart2.series = this.pichart2.dataseries.RATE_H.data;
      if (index == 0) {
        //Create Chart
        this.cropshow = true;
      } else {
        //Render Chart
        if(this.geoselect.length!=0) {
          this.$nextTick(()=>{
            this.$refs.chartref.updateOptions(this.chartOptions);
            this.$refs.chartref.updateSeries(this.series);

            this.$refs.piechartref.updateOptions(this.pichart1.chartOptions);
            this.$refs.piechartref.updateSeries(this.pichart1.series);

            this.$refs.piechartref2.updateOptions(this.pichart2.chartOptions);
            this.$refs.piechartref2.updateSeries(this.pichart2.series);
            this.$forceUpdate();
          })
        }
      }
      if (this.$parent.isFoodItemSelected) {
        this.positionX = 400;
      } else {
        this.positionX = 0;
      }
      this.visible.chart1show = true;
      this.visible.chart2show = true;
      this.visible.chart3show = true;
    },
    chartInit() {
      this.dataseries.AREA_P.data = [];
      this.dataseries.AREA_H.data = [];
      this.chartOptions.xaxis.categories = [];
      this.series = [];

      this.pichart1.dataseries.HARVEST.data = [];
      this.pichart1.chartOptions.labels = [];
      this.pichart1.series = [];

      this.pichart2.dataseries.RATE_H.data = [];
      this.pichart2.chartOptions.labels = [];
      this.pichart2.series = [];
    },
    /*<summary>
          關閉視窗
        </summary>*/
    closeWindow() {
      this.$parent.closeChartWindow();
    },
  },
  watch: {
    cropInfoShow(value) {
      if (value && this.$refs.chartref == undefined) {
        this.chartRender(0);
      } else {
        this.chartInit();
        this.cropshow = false;
      }
    },
    cropArea() {
      if (this.$refs.chartref != undefined) {
        this.chartRender(1);
      }
    },
    geoselect(val) {
      console.log(val)
      this.chartRender(1);
    }
  },
};
</script>

<style scoped>
.text-green {
  color: #4f8321;
}
.piechart {
  min-height: 220px !important;
}
.title {
  background-color: #4f8321;
  color: white;
}
.title + div {
  min-height: 220px;
}
#collapse-2 > div {
  min-height: 220px !important;
}
</style>
